<dx-select-box
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  width="100%"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-text-box class="flex-grow-1 np-highlight"
             label="{{ 'GRUPPE.NAME' | translate }}"
             [(value)]="pimField.systemKey"
             (onValueChanged)="onOrderChanged()"></dx-text-box>
